import React from 'react'

import { Avatar } from '@driftt/tide-core'

import arrowSrc from './arrow.svg'
import Sidebar from './convo-sidebar.js'

import './style.css'

const ConvoPreview = ({ color, name, email, user: { avatarUrl } }) => (
  <div className="convo-preview">
    <div className="convo-preview-message">
      <p>This is what a conversation on your site looks like!</p>
      <img className="convo-arrow-change" src={arrowSrc} alt="" />
    </div>
    <div className="convo-preview-message-container">
      <Avatar
        user={{ avatarUrl, name }}
        className="convo-preview-widget-avatar-one"
      />
      <Avatar
        user={{ avatarUrl, name }}
        className="convo-preview-widget-avatar-two"
      />
      <Sidebar backgroundColor={color} displayName={name || email} />
    </div>
  </div>
)

export default ConvoPreview
